var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"rounded-card",attrs:{"flat":"","color":_vm.color}},[_c('v-layout',{attrs:{"px-1":"","pt-2":"","pb-0":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }